import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { Button, TextField, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { getCongresoSitioConfig, putCongresoSitioConfig } from "../../../../api/congresoEdicion";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { canCreateCongresoEdicion } from "../../../../_helpers/backofficePermissions";

export default function CongresoSitioWebPage() {
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const canEditSitioUrl = canCreateCongresoEdicion(user?.role);

  const [sitioUrlOverride, setSitioUrlOverride] = useState("");
  const [sitioConfigLoading, setSitioConfigLoading] = useState(false);
  const [sitioConfigSaving, setSitioConfigSaving] = useState(false);

  const loadSitioConfig = useCallback(async () => {
    setSitioConfigLoading(true);
    try {
      const res = await getCongresoSitioConfig();
      if (res.status === 200 && res.data) {
        setSitioUrlOverride(res.data.webCongresosBaseUrlOverride || "");
      }
    } catch (e) {
      alertError({
        error: e,
        customMessage: "No se pudo cargar la configuración de la URL.",
      });
    } finally {
      setSitioConfigLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSitioConfig();
  }, [loadSitioConfig]);

  const saveSitioConfig = async () => {
    if (!canEditSitioUrl) return;
    setSitioConfigSaving(true);
    try {
      const res = await putCongresoSitioConfig({ webCongresosBaseUrl: sitioUrlOverride });
      if (res.status === 200 && res.data) {
        setSitioUrlOverride(res.data.webCongresosBaseUrlOverride || "");
        alertSuccess({
          customMessage: "URL base de la web de congresos actualizada.",
        });
      }
    } catch (error) {
      alertError({
        error,
        customMessage:
          error?.response?.data?.message ||
          "No se pudo guardar la URL. Debe empezar por http:// o https://",
      });
    } finally {
      setSitioConfigSaving(false);
    }
  };

  return (
    <Card>
      <CardHeader
        title="URL pública de la web de congresos"
      >
        <CardHeaderToolbar>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/congresos")}
            style={{ backgroundColor: "#f3691a", color: "#fff" }}
          >
            Volver a ediciones
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody style={{ paddingTop: "15px", maxWidth: 720 }}>
        {sitioConfigLoading ? (
          <Typography variant="body2">Cargando configuración…</Typography>
        ) : (
          <>
            {canEditSitioUrl ? (
              <>
                <TextField
                  label="Sobrescribir URL (opcional)"
                  placeholder="https://congresos.actedi.cat"
                  value={sitioUrlOverride}
                  onChange={(e) => setSitioUrlOverride(e.target.value)}
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  disabled={sitioConfigSaving}
                  helperText="Sin barra final obligatoria. Vacío = usar variable de entorno del API."
                />
                <div className="mt-3">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={sitioConfigSaving}
                    onClick={saveSitioConfig}
                    style={{ backgroundColor: "#f3691a", color: "#fff" }}
                  >
                    Guardar URL
                  </Button>
                </div>
              </>
            ) : (
              <Typography variant="body2" color="textSecondary">
                Solo administración (admin u operario) puede editar este valor.
              </Typography>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
}
